import { render, staticRenderFns } from "./LawsList.vue?vue&type=template&id=55d52739&scoped=true&"
import script from "./LawsList.vue?vue&type=script&lang=js&"
export * from "./LawsList.vue?vue&type=script&lang=js&"
import style0 from "./LawsList.vue?vue&type=style&index=0&id=55d52739&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d52739",
  null
  
)

export default component.exports